<template>
  <cooling-device :color="getColor" class="w-100" />
</template>

<script>
import BaseIcon from '@/components/icons/mixins/BaseIcon';

export default {
  name: 'CoolingDeviceWrapper',
  mixins: [
    BaseIcon,
  ],
  data() {
    return {
      turnedOffColor: '#CCCCCC',
      coolingOnColor: '#1DAAE1',
    };
  },
  computed: {
    getColor() {
      if (this.isCoolingOn) {
        return this.coolingOnColor;
      }
      return this.turnedOffColor;
    },
    isCoolingOn() {
      return this.getVarsValue('HVAC_COOL') || false;
    },
  },
};
</script>

<style scoped>

</style>
